import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";

export default function ClaycoBiddingInterest() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [AllLanguage, setAllLanguage] = React.useState([]);
    const [languageId, setLanguageId] = React.useState("");
    const [BiddingInterestsList, setBiddingInterestsList] = React.useState([]);
    const [Status, setStatus] = React.useState("");
    const [Name, setName] = React.useState("");
    const [Code, SetCode] = React.useState("");
    const [BiddId, setBiddId] = React.useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");

    const [open, setOpen] = useState(false);
    const [id, setID] = useState("");
    const [Search, setSearch] = useState("");
    const [state, setSate] = useState(false);
    const FreeSearch = (e) => {
        handlePageChange("1");
        setSearch(e);
    }
    const handlePageChange = (event) => {
        setNumber(event);
    };

    const handleClickOpen = (num, val) => {
        setID(num);
        setOpen(true);
        setBiddId(num == 2 ? val?.biddingInterestId : "");
        setStatus(num == 2 ? val?.status + "" : "1");
        setName(num == 2 ? val?.biddingInterestName : "")
        SetCode(num == 2 ? val?.biddingInterestCode : "")
        setLanguageId(num == 2 ? val?.languageId : "");
    };
    const handleClose = () => {
        setOpen(false);
        setSate(false);
    };

    useEffect(() => {
        Details();
        GetLanguages();
    }, [number, Search]);
    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };
    async function GetLanguages() {
        const res = await axios.get("Client/GetLanguages");
        setAllLanguage(res?.data?.data);
    }
    function Details() {
        setSpinner(!spinner);
        axios.get("SystemUser/GetClaycoBiddingInterestsList?freeText=" + Search + "&pageNumber=" + number + "&pageSize=" + 12)
            .then((res) => {
                setBiddingInterestsList(res?.data?.data);
                setCount(res?.data?.count);
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setSpinner(false);
            })


    }
    const AddorUpdate = async () => {
        setSate(true);
        if (Name != "" && languageId != ""&&Code !="") {
            const data = {
                "biddingInterestId": id == 1 ? -1 : BiddId,
                "biddingInterestCode":Code,
                "biddingInterestName": Name,
                "status": Status == 1 ? true : false,
                "isEdit": id == 1 ? false : true,
                "languageId": languageId
            }
            axios.post("SystemUser/AddOrUpdateClaycoBiddingInterest", data)
                .then((res) => {
                    if (res?.data) {
                        handleClose();
                        toastNotify(res?.data?.data, true);
                        Details();
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    setSate(false);
                })

        } else {
            toastNotify("Please Enter Mandatory Fields", false);
            setOpen(true);
            setSate(false);
        }
    }



    return (
        <>
            <Card>
                <ToastContainer />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={spinner}
                    onClick={SpinnerClose}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    <DialogContent sx={{ padding: "48px 48px" }}>
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: 20,
                            }}
                        >
                            <span style={{ fontSize: "larger" }} >{id == 1 ? " Add Clayco Bidding Interests" : " Edit Clayco Bidding Interests"}</span>
                        </DialogTitle>

                        <DialogActions >
                            <div>

                                <div>

                                    <div>
                                        <span style={{ color: "#3E4A62" }}>Name <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <TextField size='small'
                                            sx={{ width: "320px" }}
                                            value={Name || ""}
                                            onChange={(e) => setName(e.target.value)} />
                                    </div>
                                    <div>
                                        <span style={{ color: "#3E4A62" }}>Code <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <TextField size='small'
                                            sx={{ width: "320px" }}
                                            value={Code || ""}
                                            onChange={(e) => SetCode(e.target.value)} />
                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>Status </span>
                                        <br />

                                        <FormControl>

                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue="Location"
                                                name="radio-buttons-group"
                                                value={Status || ""}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <FormControlLabel value="1" control={<Radio />} label="Active" />
                                                <FormControlLabel value="0" control={<Radio />} label="In-Active" />

                                            </RadioGroup>
                                        </FormControl>

                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>Language  <span style={{ color: "red" }}>*</span></span>
                                        <br />

                                        <Select
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                width: "320px"
                                            }}
                                            labelId="demo-multiple-name-label"
                                            value={languageId || ""}
                                            id="demo-multiple-name"
                                            size="small"
                                            onChange={(e) => setLanguageId(e.target.value)}
                                            MenuProps={MenuProps}
                                        >
                                            {AllLanguage?.map((r, i) =>
                                                <MenuItem key={i} value={r?.key}>{r?.value}</MenuItem>
                                            )}
                                        </Select>

                                    </div>

                                </div>

                                <DialogActions >
                                    <div className="login-help__buttonContainer mt-4">
                                        <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                        <Button variant="contained" className="login-button-request mx-2" disabled={state == true} onClick={AddorUpdate}>{id == 1 ? "Add " : "Save"}</Button>
                                    </div>

                                </DialogActions>
                            </div >
                        </DialogActions>



                    </DialogContent>
                </Dialog>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>

                        <h3>Clayco Biddings Interest</h3>

                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <TextField
                            placeholder='Search'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome"
                            }}
                            variant="outlined"
                            size="small"
                            value={Search}
                            onChange={(e) => FreeSearch(e.target.value)}
                        />
                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                            <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                        </div>
                    </Stack >

                </div>


                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    {BiddingInterestsList?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : <>
                        <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Name of the Bidding</span>	</StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Status</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Code</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Language</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                {BiddingInterestsList?.map((r, i) => (
                                    <TableBody key={i}>
                                        <TableRow key={i} >
                                            <StyledTableCell sx={{ width: "30%" }}>
                                                {r?.biddingInterestName}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "30%" }} >
                                                {r?.status == 1 ? "Active" : "InActive"}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "30%" }}>
                                                {r?.biddingInterestCode}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {AllLanguage?.find((q) => q?.key == r?.languageId)?.value}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }} >
                                                <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r)}>
                                                    <img src={Edit} alt="editicon" />
                                                </IconButton>
                                            </StyledTableCell>

                                        </TableRow>

                                    </TableBody>
                                ))}
                            </Table>

                        </TableContainer>
                    </>}

                </Box >

            </Card>
            <div hidden={BiddingInterestsList == ""}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}